import _flatten from 'lodash-es/flatten';
import _get from 'lodash-es/get';
import _keyBy from 'lodash-es/keyBy';
import _groupBy from 'lodash-es/groupBy';
import _mapValues from 'lodash-es/mapValues';
import _omit from 'lodash-es/omit';

import { ProjectsState, ProjectStateItem } from './Reducer';

import {
  ARCHIVED_PROJECT,
  LOADED_ARCHIVED_PROJECTS,
  LOADING_ARCHIVED_PROJECTS,
  LOAD_ARCHIVED_PROJECTS_FAILED,
  CLEAR_ARCHIVED_PROJECTS,
  ProjectsAction,
} from './Actions';

const initialState: ProjectsState = {
  foldersById: {},
  projectsById: {},
  projectFoldersMap: {},
  projectsList: [],
  loading: false,
  loaded: false,
  failed: false
};

export default function archivedProjectsReducer(state = initialState, action: ProjectsAction): ProjectsState {
  switch (action.type) {
    case CLEAR_ARCHIVED_PROJECTS:
      return {
        ...initialState
      };
    case LOADED_ARCHIVED_PROJECTS:
      return {
        ...initialState,
        foldersById: _keyBy(
          _flatten(action.projects.map(x => x.folders)),
          x => x.folderId
        ),
        projectsById: _keyBy(
          action.projects.map(x => mapProject(x)),
          x => x.projectId
        ),
        projectFoldersMap: _mapValues(
          _groupBy(_flatten(action.projects.map(x => x.folders)), 'projectId'),
          grp => grp.map(x => x.folderId)
        ),
        projectsList: action.projects.map(x => x.projectId),
        loaded: true
      };
    case LOADING_ARCHIVED_PROJECTS:
      return {
        ...initialState,
        loading: true
      };
    case LOAD_ARCHIVED_PROJECTS_FAILED:
      return {
        ...initialState,
        failed: true
      };
    case ARCHIVED_PROJECT:
      // If we have archived a project add it to the archivedProjects lists
      // othewise if un-archived remove from the archivedProjects lists
      return action.project.isArchived ? {
        ...state,
        projectsList: [action.projectId].concat(
          state.projectsList
        ),
        projectsById: {
          ...state.projectsById,
          [action.projectId]: action.project
        },
        projectFoldersMap: {
          ...state.projectFoldersMap,
          [action.projectId]: action.project.folders.map(f => f.folderId)
        },
        foldersById: {
          ...state.foldersById,
          ..._keyBy(action.project.folders, f => f.folderId)
        }
      } : {
        ...state,
        projectsById: _omit(state.projectsById, action.projectId),
        projectFoldersMap: _omit(state.projectFoldersMap, action.projectId),
        projectsList: state.projectsList.filter(x => x !== action.projectId),
      };
    default:
      return state;
  }
}

function mapProject(project: TrykApi.Catalog.Favorites.IProject): ProjectStateItem {
  return {
    projectId: project.projectId,
    name: project.name,
    client: project.client,
    yardage: project.yardage,
    description: project.description,
    private: project.private,
    createdBy: project.createdBy,
    users: project.users,
    addingUser: false,
    addUserFailed: false,
    deletingUser: false,
    deleteUserFailed: false,
    dateCreated: project.dateCreated,
    dateModified: project.dateModified
  };
}
